export const memberOrderEn = {
    dingdangliebiao: "Order list",
    xiadangshijian:"Start order time",
    jieshushijian:'End time',
    shurudingdanghao:'Please enter the order number',
    shurufuwumingcheng:'Please enter the service name',
    shoushuo:'search',
    zhuantai:'state',
    caozuo:'operation',
    dingdangneirong:'Order content',
    jiage:'price',
    dingdh:'orderNum',
    xiadh:'time',
    zfdd:'Payment order',
    qxdd:'Cancellation of order',
    ypjs:'Sample delivery',
    ckxq:'View details',
    ddpj:'Order evaluation',
    ddzp:'Order review',
    ckzp:'View certificates',
    xzbg:'Download Report',
    sqdd:'Application order',
    spqxdd:'Cancel the order',
    ddbh:'Order number:',
    fahuoren:'Consignor:',
    qsrxgnr:'Please enter relevant content',
    fahuorendh:"Shipper's phone:",
    fahuorendz:"Shipper's address:",
    qxzs:'Please choose Province',
    zxzshi:'Please select the city.',
    qxzq:'Please select area',
    fahuorxxdz:"Shipper's detailed address:",
    qingsrxxdz:'Please enter the detailed address',
    shouhuor:'Consignee:',
    zsrshr:'Please enter the consignee',
    shrdh:'Consignee telephone:',
    qsrlxdh:'Please enter the contact number',
    shrdz:'Consignee address:',
    shrxxdz:"Consignee's detailed address:",
    wllx:'Logistics type:',
    qxzwllx:'Please select logistics type',
    wlbh:'Logistics No.:',
    qsrwlbh:'Please enter logistics number',
    ypmc:'Sample name:',
    qsrypmc:'Please enter the sample name',
    ypsl:'Number of samples:',
    qsrypsl:'Please input sample quantity',
    ypcl:'Sample handling:',
    huishou:'recovery',
    xiaohui:"Destruction",
    beizhu:'Remarks:',
    qsrbez:'Please enter comments',
    ddje:'Order amount:',
    fqqs:'Number of stages:',
    qi:'stage',
    zfje:'Payment amount:',
    dqzfje:'Current payment amount:',
    fuwuxq:'Service details',
    dingdh:'Order number:',
    xiadangsj:'Order time:',
    fuwulx:'Service type:',
    biaozfu:'Standard service',
    feibzfw:'Non standard services',
    dingdze:'Order total:',
    kehuzh:'Customer account number:',
    dingdzh:'Order status:',
    fuwumingc:'Service name',
    dangjia:'Unit Price',
    shuliang:'Number',
    heji:'Total',
    beizhu:'Remarks:',
    shengqrxx:'Applicant information',
    xingming:'Full name:',
    lianxdh:'contact number:',
    qiyexinxi:'company information',
    gongsimc:'conmpany name:',
    gsdizhi:'Company address:',
    zhifuxinxi:'Payment information',
    fukfs:'payment method:',
    zhifubao:'Alipay',
    weixin:'WeChat',
    yinglian:'UnionPay',
    tonglian:'Communications',
    xcxzf:'Applet payment',
    xcxxxzf:'Applet offline payment',
    xianxia:'Under the line',
    fukuansj:'Payment time',
    yingfuze:'Amount payable',
    youhuiquan:'Coupon:',
    dingdangyouhui:'Order offer:',
    baogaoxinxi:'Report information',
    baogaoxinsi:'Report form:',
    baogaotaitou:'Report title:',
    baogaoyoujidz:'Report mailing address',
    lianxiren:'Contacts:',
    dianhua:'Telephone:',
    youxiang:'Mailbox:',
    xiangxidz:'Detailed address:',
    fankuixinxi:'feedback information',
    fanhuiddlb:'Return to order list',
    jichuxinxi:'Essential information',
    shengqingbiao:'Application',
    tijiaodd:'place order',
    txsqb:'Fill in the application form',
    zhifu:'payment',
    fuwuzhong:'In service',
    xiazaibaogao:'Download reports / Reviews',
    fuwuxinxi:'Service information',
    jianchexinxi:'Detection information',
    qitazhiliao:'Other information',
    jiachixx:'Test Guide:',
    baogaobianhao:'Report No.:',
    shangcz:'Uploads:',
    shangcrx:'Upload date:',
    youxiaoqi:'Term of validity:',
    zhengshumingc:'Certificate name:',
    baogzxx:'Report general information',
    fujianxiazai:'Attachment Download',
    quanbuxz:'Download all',
    fanhuizsgl:'Return to certificate management',
    zhengsdy:'Certificate printing',
    daochupdf:'Export PDF file',
    xiangshang:'Online payment',
    xiangxia:'Offline payment',
    zhifufangshi:'mode of payment',
    fukuandanbianhao:'Bill of payment Number',
    fukuanleixing:'Type of payment',
    xiangshang1:'on-line',
    zhuantai:'status',
    fankuiyijian:'feedback',
}


// WEBPACK FOOTER //
// ./src/lang/member/memberOrder/memberOrderEn.js